import { FC } from 'react';
import { useState } from '@hookstate/core';
import { useTranslation } from 'react-i18next';
import { MessageModal as MessageModalComponent } from '../../components/MessageModal';
import { meta, closeModal } from '../../stores/backend';

export const MessageModal: FC = () => {
    const { t } = useTranslation();

    const $meta = useState(meta);

    const modalName = $meta.modals.msgCommon.name.value;
    const message = t(modalName) || t('error.general');
    const isReconnectModal = modalName === 'error.socketConnectionInterrupted';
    const isWaitModal = modalName === 'error.socketConnectionInterruptedWait';
    const isScreenConfigErrorModal =
        modalName === 'error.not.authenticated' ||
        modalName === 'error.general';

    const onClose = () => closeModal('msgCommon');
    const handleReload = () => window.location.reload();

    return (
        <MessageModalComponent
            onClose={isWaitModal ? onClose : handleReload}
            message={message}
            isOpen={$meta.modals.msgCommon.isOpen.value}
            hideCloseButton={isScreenConfigErrorModal}
            showButton={isReconnectModal}
            buttonText={isReconnectModal ? t('messageModal.reload') : undefined}
            onButtonClick={isReconnectModal ? handleReload : undefined}
        />
    );
};
